import React, { Component } from 'react'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

export default class TopNav extends Component {
	toggleCartDrawer = e => {
		e.preventDefault()
		const cartDrawerEl = document.querySelector('#cart-drawer')

		if (
			document
				.querySelector('#favorites-drawer')
				.classList.contains('show')
		) {
			document.querySelector('#favorites-drawer').classList.remove('show')
		}

		cartDrawerEl.classList.toggle('show')
		document.querySelector('body').classList.toggle('modal-open')
	}

	toggleFavoriteDrawer = e => {
		e.preventDefault()
		const favoritesDrawer = document.querySelector('#favorites-drawer')

		if (document.querySelector('#cart-drawer').classList.contains('show')) {
			document.querySelector('#cart-drawer').classList.remove('show')
		}

		favoritesDrawer.classList.toggle('show')
		document.querySelector('body').classList.toggle('modal-open')
	}
	render() {
		return (
			<div id='top-nav' className='hidden-sm hidden-xs'>
				<div className='container'>
					<div className='row'>
						<div className='col-md-6'>
							{/* <a href='tel:512-123-0987' className='semi-bold'>
								Contact Us: (512)123-0987
							</a> */}
						</div>
						<div className='col-md-6 text-right'>
							<a href='/login'>Login/Signup</a>
							&emsp;
							<a
								onClick={this.toggleCartDrawer}
								href='/'
								className='show-cartmenu'>
								View Cart:
								<FAI icon='shopping-cart' />
								<span>3</span>
							</a>
							&emsp;
							<a href='/' onClick={this.toggleFavoriteDrawer}>
								View Favorites: &nbsp;
								<FAI icon='heart' />
								&nbsp;
								<span>2</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
